var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.0833L10 12.8333L18.3333 3.66667M17.5 11V17.4167C17.5 17.9029 17.3244 18.3692 17.0118 18.713C16.6993 19.0568 16.2754 19.25 15.8333 19.25H4.16667C3.72464 19.25 3.30072 19.0568 2.98816 18.713C2.67559 18.3692 2.5 17.9029 2.5 17.4167V4.58333C2.5 4.0971 2.67559 3.63079 2.98816 3.28697C3.30072 2.94315 3.72464 2.75 4.16667 2.75H13.3333",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.ed8c6c612ea0ce285ae3d5745aad27e2.svg";
export { ForwardRef as ReactComponent };